import React from 'react';
import PropTypes from 'prop-types';

import {
    useCurationConfigState
} from '../../../hooks/widgetConfiguration.js';

import RIQButton from '../../../components/RIQButton.jsx';


TableLayoutSelector.propTypes = {
    instanceId: PropTypes.string.isRequired
};


export default function TableLayoutSelector({instanceId}) {
    const [layout, setLayout] = useCurationConfigState(instanceId, 'layout');

    const onClick = (option) => {
        setLayout(option);
    };

    let wordCloudClasses;
    let tableClasses;
    const selectedLayoutClasses = 'tlw-bg-gray-800 tlw-text-white tlw-border-gray-850';
    const unselectedLayoutClasses = 'tlw-bg-white tlw-border-gray-600 tlw-text-gray-800 hover_tlw-bg-gray-100';
    if (layout === 'wordcloud') {
        wordCloudClasses = selectedLayoutClasses;
        tableClasses = `${unselectedLayoutClasses} tlw-border-l-0`;
    } else {
        wordCloudClasses = `${unselectedLayoutClasses} tlw-border-r-0`;
        tableClasses = selectedLayoutClasses;
    }

    return (
        <div>
            <RIQButton
                variant='select-left'
                className={`fa fa-comments-o tlw-text-lg ${wordCloudClasses}`}
                onClick={() => onClick('wordcloud')}
            />
            <RIQButton
                variant='select-right'
                className={`fa fa-table tlw-text-lg ${tableClasses}`}
                onClick={() => onClick('table')}
            />
        </div>
    );
}
